import type { RateData } from './types';

const parseRateValue = (val: unknown): number | null => {
    if (val === null || val === undefined) return null;
    const s = String(val).trim();
    if (s === '') return null;
    const num = parseFloat(s.replace(/[^\d.-]/g, ''));
    return Number.isNaN(num) ? null : num;
};

export const classToRateColumn = (cls: string): keyof RateData =>
    `${cls.toLowerCase()}_rate` as keyof RateData;

/**
 * Pick the displayable rate value for one row of the `rates` table, using
 * the carrier's crop_classes entry to decide which class column to read.
 *
 * Returns null when the carrier has no crop_classes entry for the active
 * crop — that carrier does not quote the crop and must not appear in the
 * HPT results. An earlier fallback would scan every class column belonging
 * to any carrier of the crop and surface whichever column held a number,
 * causing carriers like Great American (no Garbanzo Beans crop_classes
 * row in ID) to inherit Rain & Hail's B-class rate.
 */
export function selectCarrierRate(
    record: RateData,
    carrierClassMap: Map<string, string[]>
): number | string | null {
    const carrier = record.carrier;
    if (!carrier) return null;
    const classes = carrierClassMap.get(carrier);
    if (!classes || classes.length === 0) return null;
    for (const cls of classes) {
        const column = classToRateColumn(cls);
        const raw = record[column];
        if (parseRateValue(raw) !== null) {
            return raw as number | string;
        }
    }
    return null;
}
